import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { withNamespaces } from 'react-i18next';
import  './css/AdminConfig.css';
import './js/AdminConfig'
//import './css/poiManagement.css';

import SideBarAdmin from '../../components/AdminConfig/SideBarAdmin';
import UserInformation from '../../components/AdminConfig/Content/UserInformation';
import POIconfig from '../../components/AdminConfig/Content/POIconfig';
import ViewTemporary from '../../components/AdminConfig/Content/ViewTemporary';
import News from '../../components/AdminConfig/Content/News';
import DeviceInformation from '../../components/AdminConfig/Content/DeviceInformation';
import DealerInfo from '../../components/AdminConfig/Content/DealerInfo';
import MenuBar from '../../components/MenuBar/MenuBar'
import SideBarToggle from '../../components/AdminConfig/Content/SideBarToggle';
import {getMainCookie} from '../../../util/util';
import Drivers from '../../components/AdminConfig/Content/Drivers';
import AccessLog from '../../components/AdminConfig/Content/AccessLog';


class AdminConfig extends Component {

    constructor() {
        super();

        this.state = {
            isClickUserInformation: true,
            isClickPOIconfig: false,
            isClickViewTemporary: false,
            isClickNews: false,
            isClickDeviceInformation: false,
            isClickDealerInfo: false,
            sideBarName: '',
            userLevel: 0,
            user_name: '',
            user_id: 0,
            token: '',
            isClickCustomerInfo:false,
            isClickDrivers:false,
            isAdminConfigTap: true,
            isClickAccessLog: false,
            isClickReport: false,
            objFromDeviceUserRelated: {},
            objDeviceUserRelated: {}
        };

    }
    componentWillMount() {
        const cookieObj = getMainCookie();
        const { history } = this.props;
        this.setState({
            userLevel: cookieObj.user_level,
            user_name: cookieObj.login_name,
            user_id: cookieObj.user_id,
            token: cookieObj.token,
            objFromDeviceUserRelated: {}
    });
    }

    componentDidMount() {
        $('#sidebar').toggleClass('active');
        $('#sidebarAdminCollapse').on('click', function () {
            $('#sidebar').toggleClass('active');

                for(let i=0;i<$('#adminSidebar>li').length;i++){
                    if($('#adminSidebar>li')[i].className.indexOf('menumini')>-1)
                        $('#adminSidebar>li')[i].className="";
                    else
                        $('#adminSidebar>li')[i].className="menumini";
                }

        });
        this.setListClick();
    }

    componentWillReceiveProps(nextProps) {
        const { location } = this.props;
        if (location.state !== nextProps.location.state && Object.prototype.hasOwnProperty.call(nextProps.location.state, 'sideBarName')) {
         if (nextProps.location.state.sideBarName === 'deviceInformation') {
             this.setState({objFromDeviceUserRelated: nextProps.location.state}, () => this.onClickSideBar(nextProps.location.state.sideBarName));
             // this.onClickSideBar(nextProps.location.state.sideBarName);
         }
        }

        if (location.state !== nextProps.location.state && (nextProps.location.state.sideBarName === 'dealerInfo' || nextProps.location.state.sideBarName === 'customerInfo' || nextProps.location.state.sideBarName === 'employeeInfo' || nextProps.location.state.sideBarName === 'adminInfo')) {
            this.setState({objDeviceUserRelated: nextProps.location.state}, () => this.onClickSideBar(nextProps.location.state.sideBarName));
        }
    }

    componentDidUpdate(){
        this.setListClick();
    }

    setListClick(){
        $('.list-unstyled li').click(function(e) {
            e.preventDefault()

            let that = $(this);

            that.parent().parent().parent().parent().find('li').removeClass('sub-active');
            that.addClass('sub-active');

            if(that.parent().parent().parent()[0].className.indexOf('menumini')>-1){
                that.parent().removeClass('show');
                that.parent().parent().parent().parent().parent().find('a').attr("aria-expanded","false");
                that.parent().parent().parent().find('.dropdown-toggle').attr("aria-expanded","true")

            }

        });
        console.log('Kyyyyy:::');

    }

    componentWillUnmount() {
        this.setState({
            isClickUserInformation: {},
            isClickPOIconfig: {},
            isClickViewTemporary: {},
            isClickNews: {},
            isClickDeviceInformation:{},
            isClickDealerInfo: {},
            isAdminConfigTap: false,
            objFromDeviceUserRelated: {}
        });
    }

    onClickSideBar = (sideBarName) => {
        if (sideBarName !== 'deviceInformation') {
            this.setState({ objFromDeviceUserRelated: {} });
        }
        if (sideBarName !== 'dealerInfo' && sideBarName !== 'employeeInfo' && sideBarName !== 'adminInfo' &&
            sideBarName !== 'customerInfo' ) {
            this.setState({ objDeviceUserRelated: {} });
        }

        if (sideBarName === 'userInfo') {
            this.setState({
                isClickUserInformation: true,
                isClickPOIconfig: false,
                isClickViewTemporary: false,
                isClickNews:false,
                isClickDeviceInformation:false,
                isClickDealerInfo: false,
                isClickCustomerInfo:false,
                isClickDrivers:false,
                isClickAccessLog:false
            });
        } else if (sideBarName === 'poiConfig') {
            this.setState({
                isClickUserInformation: false,
                isClickPOIconfig: true,
                isClickViewTemporary: false,
                isClickNews:false,
                isClickDeviceInformation:false,
                isClickDealerInfo: false,
                isClickCustomerInfo:false,
                isClickDrivers:false,
                isClickAccessLog:false
            });
        } else if (sideBarName === 'viewTemporary') {
            this.setState({
                isClickUserInformation: false,
                isClickPOIconfig: false,
                isClickViewTemporary: true,
                isClickNews:false,
                isClickDeviceInformation:false,
                isClickDealerInfo: false,
                isClickCustomerInfo:false,
                isClickDrivers:false,
                isClickAccessLog:false,
            });
        }else if (sideBarName === 'news') {
            this.setState({
                isClickUserInformation: false,
                isClickPOIconfig: false,
                isClickViewTemporary: false,
                isClickNews:true,
                isClickDeviceInformation:false,
                isClickDealerInfo: false,
                isClickCustomerInfo:false,
                isClickDrivers:false,
                isClickAccessLog:false,
            });
        }else if (sideBarName === 'deviceInformation') {
            this.setState({
                isClickUserInformation: false,
                isClickPOIconfig: false,
                isClickViewTemporary: false,
                isClickNews:false,
                isClickDeviceInformation:true,
                isClickDealerInfo: false,
                isClickCustomerInfo:false,
                isClickDrivers:false,
                isClickAccessLog:false,
            });
        }else if (sideBarName === 'dealerInfo' || sideBarName === 'employeeInfo' || sideBarName === 'adminInfo') {
            this.setState({
                sideBarName,
                isClickUserInformation: false,
                isClickPOIconfig: false,
                isClickViewTemporary: false,
                isClickNews:false,
                isClickDeviceInformation:false,
                isClickDealerInfo: true,
                isClickCustomerInfo:false,
                isClickDrivers:false,
                isClickAccessLog:false,
            });
        }else if(sideBarName === 'customerInfo'){
            this.setState({
                sideBarName,
                isClickUserInformation: false,
                isClickPOIconfig: false,
                isClickViewTemporary: false,
                isClickNews:false,
                isClickDeviceInformation:false,
                isClickDealerInfo: false,
                isClickCustomerInfo:true,
                isClickDrivers:false,
                isClickAccessLog:false,
            });
        }else if(sideBarName === 'Drivers'){
            this.setState({
                sideBarName,
                isClickUserInformation: false,
                isClickPOIconfig: false,
                isClickViewTemporary: false,
                isClickNews:false,
                isClickDeviceInformation:false,
                isClickDealerInfo: false,
                isClickCustomerInfo:false,
                isClickDrivers:true,
                isClickAccessLog:false,
            });
        }else if(sideBarName === 'accessLog'){
            this.setState({
                sideBarName,
                isClickUserInformation: false,
                isClickPOIconfig: false,
                isClickViewTemporary: false,
                isClickNews:false,
                isClickDeviceInformation:false,
                isClickDealerInfo: false,
                isClickCustomerInfo:false,
                isClickDrivers:false,
                isClickAccessLog:true,
            });
        } else if(sideBarName === 'report') {

        }
    }

    render() {
      const {
        isClickUserInformation,
        isClickPOIconfig,
        isClickViewTemporary,
        isClickNews,
        isClickDeviceInformation,
        isClickDealerInfo,
        sideBarName,
        userLevel,
        user_name,
        user_id,
        token,
        isClickCustomerInfo,
        isClickDrivers,
        isAdminConfigTap,
        isClickAccessLog,
        isClickReport,
        objFromDeviceUserRelated,
        objDeviceUserRelated
      } = this.state;
      const {
          t,
          history
      } = this.props;
    return (
      <div style={{marginTop: 50}} >
         <MenuBar tab_adminconf="active"/>
         <div className="wrapper admin">
              {/* Sidebar  */}
            <nav id="sidebar">
                <SideBarAdmin
                    // onClickUserInformation={this.onClickUserInformation}
                    // onClickPOIconfig={this.onClickPOIconfig}
                    isAdminConfigTap={isAdminConfigTap}
                    onClickSideBar={this.onClickSideBar}
                    userLevel={userLevel}

                />
            </nav>

            <div id="content">
                <SideBarToggle/>
                { isClickUserInformation &&
                    <UserInformation
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                    />
                }
                {isClickPOIconfig &&
                    <POIconfig
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                    />
                }
                {isClickViewTemporary &&
                    <ViewTemporary />
                }
                {isClickNews &&
                    <News/>
                }
                {isClickDeviceInformation &&
                    <DeviceInformation
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        sideBarName={sideBarName}
                        objFromDeviceUserRelated={objFromDeviceUserRelated}
                        history={history}
                    />
                }
                {isClickDealerInfo &&
                    <DealerInfo
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        sideBarName={sideBarName}
                        history={history}
                        objDeviceUserRelated={objDeviceUserRelated}
                    />
                }
                 {isClickCustomerInfo &&
                    <DealerInfo
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        sideBarName={sideBarName}
                        history={history}
                        objDeviceUserRelated={objDeviceUserRelated}
                    />
                }
                {isClickDrivers &&
                    <Drivers
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        sideBarName={sideBarName}
                    />
                }
                {isClickAccessLog &&
                    <AccessLog
                        userLevel={userLevel}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        sideBarName={sideBarName}/>
                }
                {isClickReport &&
                    console.log('isClickReport:::::')
                }
            </div>
        </div>
      </div>
    );
  }
 }

AdminConfig.defaultProps = {
    location: {}
};


AdminConfig.propTypes = {
    history: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired
}
export default withNamespaces('Menubar')(AdminConfig);



// WEBPACK FOOTER //
// ./src/app/view/containers/AdminConfig/AdminConfig.js